const crossfadeDurationMs = 225;
const wrapper = "_35sw1u9klof";
const toggle = "_35stnr062n";
const transitionWrapper = "_35stgyq5ti";
const container = "_35sc1blmrwt";

export { container, crossfadeDurationMs, toggle, transitionWrapper, wrapper };
import "./organism.facit-container.style.linaria.module.css";
//# sourceMappingURL=organism.facit-container.style.js.map
